import * as S from './Button.styled'
import Icon from 'components/priority/Icon/Icon'
import type { ButtonComponentProps } from 'types/button'

export const Button = ({
  children,
  icon,
  iconLeft,
  ...props
}: ButtonComponentProps) => (
  <S.Button {...props}>
    {iconLeft && <Icon icon={iconLeft} margin="0 8px 0 0" />}
    {children}
    {icon && <Icon icon={icon} margin="0 0 0 8px" />}
  </S.Button>
)

export default Button
